/**
 * Legal identity of the association operating this website.
 * Single source of truth so that the same official wording is used everywhere.
 */
export const ORGANIZATION = {
  legalName: "Falc'Ohm System ASBL",
  companyNumber: "0744.675.235",
  vatNumber: "BE 0744.675.235",
  email: "falcohm6tm@outlook.com",
  websiteUrl: "https://falcohmsystem.com",
  websiteLabel: "falcohmsystem.com",
  address: {
    street: "Rue des Croix du Feu 4",
    postalCode: "1473",
    city: "Glabais",
    country: "Belgique",
  },
} as const;

export const ORGANIZATION_ADDRESS_INLINE = `${ORGANIZATION.address.street}, ${ORGANIZATION.address.postalCode} ${ORGANIZATION.address.city}, ${ORGANIZATION.address.country}`;
